import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {FormattedTime, FormattedDate, FormattedNumber} from 'react-intl';
import {
    Button,
    Container,
    Header,
    Grid,
    Table
} from 'semantic-ui-react';

import Alert from "../../components/extras/Alert";
import c from "../../constants";
import QuestionDialog from "../../components/extras/QuestionDialog";
import CloseBoxData from "../../data/CloseBoxData";
import Loading from "../../components/extras/Loading";
import localDB from "../../data/localDB";
import * as moment from "moment";
import SimpleTable from "../extras/SimpleTable";
import PartialOpenBoxDialog from "../sale/PartialOpenBoxDialog";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {partialOpenBoxDialog} from "../../actions/PartialOpenBoxDialogActions";
import {simpleTableAddOrUpdate, simpleTableDelete} from "../../actions/SimpleTableDataActions";
import PartialOpenBoxData from "../../data/PartialOpenBoxData";
import AccessDenied from "../../containers/AccessDenied";

class CloseBoxDetail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: {
                branch_office: {id: '----', name: '----'},
                code: 0,
                count_sales: 0,
                amount: 0,
                total_cancel_sales: 0,
                id: null,
                start_date: new Date().toString(),
                total_sales: 0,
                user: {full_name: '----', id: null},
                payment_types: []
            },
            table: {
                headers: ['Fecha', 'Usuario', 'Valor', 'Acciones'],
                title: 'Cierres Parciales',
                has_actions: localDB.get('store_security').can_close_box,
                edit: true,
                delete: true,
                url: this.props.is_current ? 'open-box-current/partial':`partial-open-box-list/${this.props.id}`,
                values: ['id', 'amount', 'date', 'user'],
                child_fields: [{user:'full_name'}],
                money_fields: ['amount'],
                datetime_fields: ['date'],
                id: 'table_partial_boxes'
            },
            loading: true,
            cash: 0,
        };
        this.closeBoxConfirm = this.closeBoxConfirm.bind(this);
    }

    async componentWillMount() {
        await this.getData();
    }

    async getData() {
        if(this.props.is_current){
            await this.getCurrent();
        }else if(this.props.id){
            this.get(this.props.id);
        }
    }

    async componentWillReceiveProps(nextProps){
        if(nextProps.select_partial_open_box && nextProps.select_partial_open_box.hasOwnProperty('id')){
            this.props.simpleTableAddOrUpdate(nextProps.select_partial_open_box);
            await this.getData();
        }
    }

    closeBoxConfirm = () => {
        let data = {close: true, id: this.state.data.id};
        CloseBoxData.put(data, (res) => {
            if (res.closed) {
                let box = localDB.get('box');
                box.is_open = false;
                box.end_date = moment.now();
                localDB.set('box', box);
                this.props.history.push(`/sales/boxes/${res.id}/${res.code}`);
            } else {
                this.refs.alert.open({message: res.message, type: 'error'});
            }
        });
    };

    async getCurrent() {
        let data = await CloseBoxData.getCurrent();
        data.end_date = new Date();
        localDB.set('box', data);
        if (this.props.is_current && !data.is_open){
            this.props.history.push('/sale');
        }
        if(data.payment_types.length > 0){
            let cash_total = data.payment_types.find(payment => payment.id === 1) ;
            this.setState({ data, loading: false, cash: cash_total ? cash_total.total:0});
        }else{
            this.setState({loading:false, data});
        }
    };

    async get(id){
        this.setState({loading:true});
        let data = await CloseBoxData.get(id);
        data.end_date = new Date();
        localDB.set('box', data);
        if(data.payment_types.length > 0) {
            let payment_type_cash = data.payment_types.find(payment => payment.id === 1)
            if(!payment_type_cash){
                payment_type_cash = {'total': 0}
            }

            console.log(payment_type_cash)
            this.setState({data, loading: false, cash: payment_type_cash.total});
        }else {
            this.setState({loading:false, data});
        }
    };

    handleAmountChange(event) {
        this.setState({amount: event.target.value});
        if (event.target.value.trim() === '' || event.target.value < 0) {
            this.setState({amount_error: true});
        } else {
            this.setState({amount_error: false});
        }
    };

    callbackDynamicTable = (response) => {
        if(response.event === 'edit'){
            this.props.partialOpenBoxDialog({open:true, partial_open_box:response.data});
        }else if(response.event === 'delete'){
            this.refs.delete_partial_open_box.open('', response.data.id);
        }
    };

    deletePartialCloseBox = (id) => {
        PartialOpenBoxData.delete(id, (res) => {
            if (res === null) {
                this.props.simpleTableDelete(id);
                this.props.showToast({message: 'Cierre Parcial Borrado!', type: 'success'});
                this.getData();
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        });
    };

    render() {
        if(!localDB.get('store_security').can_view_box){
            return <AccessDenied />
        }
        return (
            <div>
                {this.state.loading ? <Loading/>:<Container>
                    <Grid stackable centered>
                        <Grid.Row>
                            <Header as='h2' textAlign='center'>
                                <Header.Content>
                                    Cierre de Caja <strong>Nº:{this.state.data.code}</strong>
                                </Header.Content>
                            </Header>
                        </Grid.Row>
                        <Grid.Row columns={2}>
                            <Grid.Column>
                                <Table>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell textAlign='right'>Fecha y Hora de Apertura</Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong><FormattedDate
                                                    value={this.state.data.start_date}/> - <FormattedTime
                                                    value={this.state.data.start_date}/></strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign='right'>Usuario</Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong>{this.state.data.user.full_name}</strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign='right'>Sucursal</Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong>{this.state.data.branch_office.name}</strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign='right'>Valor Apertura</Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong>$<FormattedNumber value={this.state.data.amount}
                                                                          currency="USD" maximumFractionDigits={0}
                                                                          minimumFractionDigits={0}/></strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign='center'>Medios de Pago</Table.Cell>
                                            <Table.Cell>
                                                <Table basic>
                                                    <Table.Body>
                                                        {this.state.data.payment_types.length > 0 ? this.state.data.payment_types.map((payment_type) => {
                                                            return <Table.Row key={payment_type.id}>
                                                                <Table.Cell textAlign='right'>{c.PAYMENT_TYPES.find(type => {return type.key === payment_type.id }).text}</Table.Cell>
                                                                <Table.Cell textAlign='left'>
                                                                    <strong>$<FormattedNumber value={payment_type.total}
                                                                                              currency="USD" maximumFractionDigits={0}
                                                                                              minimumFractionDigits={0}/></strong>
                                                                </Table.Cell>
                                                            </Table.Row>
                                                        }):<Table.Row><Table.Cell textAlign='center' colSpan={2}>No se han realizado pagos</Table.Cell></Table.Row>}
                                                    </Table.Body>
                                                </Table>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign='center'>Gastos</Table.Cell>
                                            <Table.Cell>
                                                <Table basic>
                                                    <Table.Body>
                                                        {this.state.data.expenses_by_payment_method.length > 0 ? this.state.data.expenses_by_payment_method.map((expense) => {
                                                            return <Table.Row key={expense.payment_method}>
                                                                <Table.Cell textAlign='right'>{expense.text}</Table.Cell>
                                                                <Table.Cell textAlign='left'>
                                                                    <strong>$<FormattedNumber value={expense.total} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/></strong>
                                                                </Table.Cell>
                                                            </Table.Row>
                                                        }):<Table.Row><Table.Cell textAlign='center' colSpan={2}>No se han realizado gastos</Table.Cell></Table.Row>}
                                                    </Table.Body>
                                                </Table>
                                            </Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </Grid.Column>
                            <Grid.Column>
                                <Table>
                                    <Table.Body>
                                        <Table.Row positive>
                                            <Table.Cell textAlign='right'><strong>Ingresos</strong></Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong>$<FormattedNumber value={this.state.data.total_sales ? this.state.data.total_sales:0}
                                                                          currency="USD" maximumFractionDigits={0}
                                                                          minimumFractionDigits={0}/></strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row error>
                                            <Table.Cell textAlign='right'><strong>Gastos</strong></Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong>$<FormattedNumber value={this.state.data.expenses ? this.state.data.expenses:0}
                                                                          currency="USD" maximumFractionDigits={0}
                                                                          minimumFractionDigits={0}/></strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row error>
                                            <Table.Cell textAlign='right'><strong>Ventas Anuladas</strong></Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong>$<FormattedNumber value={this.state.data.total_cancel_sales ? this.state.data.total_cancel_sales:0}
                                                                          currency="USD" maximumFractionDigits={0}
                                                                          minimumFractionDigits={0}/></strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row error>
                                            <Table.Cell textAlign='right'><strong>Descuentos</strong></Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong>$<FormattedNumber value={this.state.data.discounts}
                                                                          currency="USD" maximumFractionDigits={0}
                                                                          minimumFractionDigits={0}/></strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign='right'><strong>Propinas</strong></Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong>$<FormattedNumber value={this.state.data.tips}
                                                                          currency="USD" maximumFractionDigits={0}
                                                                          minimumFractionDigits={0}/></strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign='right'><strong>Cierres Parciales</strong></Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <strong>$<FormattedNumber
                                                    value={this.state.data.partial_open_box}
                                                    currency="USD" maximumFractionDigits={0}
                                                    minimumFractionDigits={0}/></strong>
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row positive>
                                            <Table.Cell textAlign='right'><h2>En Caja</h2></Table.Cell>
                                            <Table.Cell textAlign='left'>
                                                <h2>$<FormattedNumber
                                                    value={(this.state.data.amount + this.state.cash) - (this.state.data.by_cash_open_box + this.state.data.partial_open_box)}
                                                    currency="USD" maximumFractionDigits={0}
                                                    minimumFractionDigits={0}/></h2>
                                            </Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                                {localDB.get('store_security').can_close_box && this.state.data.is_open ?<Button.Group fluid>
                                    <Button primary onClick={() => this.refs.question_dialog.open('Cerrar Caja')}>Cerrar Caja</Button>
                                    <Button.Or text=''/>
                                    <Button onClick={() => this.props.partialOpenBoxDialog({open:true,
                                        cash:(this.state.data.amount + this.state.cash) - (this.state.data.expenses + this.state.data.partial_open_box),
                                        partial_open_box:{id:null, amount:0}
                                    })}>Cierre Parcial</Button>
                                </Button.Group>:null}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <SimpleTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                        </Grid.Row>
                    </Grid>
                    <Alert ref='alert'/>
                    <QuestionDialog ref='question_dialog' message="cerrar esta caja" callbackConfirm={this.closeBoxConfirm}/>
                    <QuestionDialog ref="delete_partial_open_box" message="borrar este cierre parcial" callbackConfirm={this.deletePartialCloseBox}/>
                    <PartialOpenBoxDialog open_box={this.state.data.id}/>
                </Container>}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        select_partial_open_box: state.get('select_partial_open_box'),
    };
}

function mapDispatchToProps(dispatch){
    return {
        partialOpenBoxDialog(modal){
            dispatch(partialOpenBoxDialog(modal))
        },
        simpleTableAddOrUpdate(data){
            dispatch(simpleTableAddOrUpdate(data))
        },
        simpleTableDelete(data){
            dispatch(simpleTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(CloseBoxDetail));



// WEBPACK FOOTER //
// ./src/components/open_box/CloseBoxDetail.js